export default {
    namespaced: true,

    state: {
        latest_valuation_date: null,
        purchase_date: null,
        min_valuation_date: null,
    },

    mutations: {
        setData(state, data) {
            state.purchase_date = data.purchase_date;
        },

        setLatestValuationDate(state, date) {
            state.latest_valuation_date = date;
        },

        setMinValuationDate(state, date) {
            state.min_valuation_date = date;
        },

        reset(state) {
            state.currency_balance_owing_in_cents = 0;
            state.transaction_date = '';
        },
    },
};
